import { ReactElement } from "react";

import { Box, DataRow, Typography } from "@portex-pro/ui-components";

const InternalReferenceNumberRowView = ({ reference }: { reference: string }): ReactElement => {
  return (
    <DataRow label={"Internal Reference No."}>
      <Box ml="3rem">
        <Typography display={"inline"}>
          <strong>{reference}</strong>
        </Typography>
      </Box>
    </DataRow>
  );
};

export default InternalReferenceNumberRowView;
